import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone! I’m <span className="purple">Abhishek Choudhary</span>{" "}
            from <span className="purple">Indore, India</span>.
            <br />
            I’m currently a{" "}
            <span className="purple">student</span> at{" "}
            <span className="purple">Ips Academy Indore</span>.
            <br />I am pursuing Bachelor of technology(BTech) in{" "}
            <span className="purple">CSE AI-ML</span> from{" "}
            <span className="purple">IPS Academy Indore</span>.
            <br />
            <br />
            Outside of coding, I love engaging in activities that keep me
            creative and inspired:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Sports🏏⚽
            </li>
            <li className="about-activity">
              <ImPointRight /> Listening to Music 🎧
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling and Exploring New Places 🌍
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Building solutions that make an impact!"{" "}
          </p>
          <footer className="blockquote-footer">Abhishek</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;